module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "grey lighten-4 ma-0 pa-0",
    attrs: {
      "dense": _vm.dense
    }
  }, [_c('practitioner-list-item', {
    attrs: {
      "item": _vm.selected
    },
    on: {
      "selected": function($event) {
        _vm.showmenu = false;
        _vm.showmenu = true
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function(props) {
        return [(props.fullname) ? _c('v-list-tile-title', [_vm._v(_vm._s(props.fullname))]) : _c('v-list-tile-title', [_vm._v("Choose a practitioner")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list-tile-action', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("expand_more")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showmenu),
      callback: function($$v) {
        _vm.showmenu = $$v
      },
      expression: "showmenu"
    }
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 my-0 grey lighten-2"
  }, [_vm._v("Pick a practitioner")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.practitioners), function(practitioner, index) {
    return _c('practitioner-list-item', {
      key: practitioner.id,
      class: {
        "blue lighten-5": _vm.isSelected(practitioner)
      },
      attrs: {
        "item": _vm.practitioners[index],
        "badge-color": "success",
        "badge-icon": _vm.getSelectedIcon(practitioner)
      },
      on: {
        "selected": _vm.setSelected
      }
    })
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e01d4f1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/PractitionerPicker.vue
// module id = 1371
// module chunks = 9